export const Input = ({ label, id, type = "text", ...props }) => (
  <div className="w-full">
    {label && <label htmlFor={id} className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5">{label}</label>}
    <input
      id={id}
      type={type}
      className="w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2 text-sm text-slate-800 placeholder-slate-400 transition-all focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/10 disabled:bg-slate-50 disabled:text-slate-400"
      {...props}
    />
  </div>
);